module.exports = __webpack_public_path__ + "static/media/chat.f72e5411.svg";